// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/imsafe.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/imsafe/imsafe.js';

mount([g0]);
